import { Box, Modal } from '@mui/material';
import { AJOList, AJOState } from 'mp-js-react-auto-json-object';
import { Button } from 'flowbite-react';
import { Component } from 'react';
import { Spinner } from '../../commun/component/Spinner';
import { JSXInternal } from 'preact/src/jsx';
import { get } from '../../commun/HTTP';
import Result from '../../commun/Result';
import MpModal, { IBaseModalProps } from '../extends/MpModal';
import { SelectClientList } from './SelectClientList';
import Client from 'src/object/profile/Client';

export interface ISelectClientModalProps extends IBaseModalProps {
    selectList: Client[];
    onSelectList: (list: Client[]) => void;
}

export interface ISelectClientModalState {
    selectList: Client[];
    loading: boolean;
    list: AJOState<AJOList<Client>>;
}

export default class SelectClientModal extends Component<ISelectClientModalProps, ISelectClientModalState> {
    constructor(props: ISelectClientModalProps) {
        super(props);

        this.state = this.initState();
    }

    initState() {
        const p: ISelectClientModalState = {
            selectList: this.props.selectList,
            loading: false,
            list: new AJOState<AJOList<Client>>(new AJOList<Client>(Client)),
        };
        p.list.setUpdate((a) => {
            this.setState({
                list: a,
            });
        });
        if (this.props.open) {
            p.loading = true;
            get('/client/list', {}).then((res: any) => {
                this.setState({
                    loading: false,
                });
                if (Result.isSuccess(res)) {
                    Result.applyResult(res, this.state.list, true);
                }
            });
        }
        return p;
    }

    componentDidUpdate(
        prevProps: Readonly<ISelectClientModalProps>,
        prevState: Readonly<ISelectClientModalState>,
        snapshot?: any,
    ): void {
        if (prevProps.open !== this.props.open) {
            this.setState(this.initState());
        }
    }

    render(): JSXInternal.Element {
        const { open, onClose } = this.props;
        const { loading } = this.state;
        return (
            <MpModal
                open={open}
                onClose={onClose}
                onSubmit={() => {
                    this.props.onSelectList(this.state.selectList);
                    onClose();
                }}
                title="Sélectionner des clients"
                done="Sélectionner"
            >
                {loading ? (
                    <Box className="flex items-center justify-center py-12">
                        <Spinner color="blue" className="" />
                    </Box>
                ) : (
                    <SelectClientList
                        list={this.state.list.get()!.getList()}
                        selectList={this.state.selectList}
                        onSelectList={(list) => {
                            this.setState({
                                selectList: [...list],
                            });
                        }}
                    />
                )}
            </MpModal>
        );
    }
}
